import { QuotePropTypes } from "./propTypes";
import { useRef } from "react";
import "./styles.scss";
import clsx from "clsx";
import { motion, useInView } from "framer-motion";
import userDarkIcon from "@/assets/img/user-dark-icon.svg";

/* #META
 {
  "NAME": "Quote",
  "CLASSNAME": "quote-section",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const QuoteComponent = ({ data }) => {
  const quoteData = data?.quote_component || {};
  const {
    client_name: clientName,
    client_role: clientRole,
    quote_content: quoteContent,
    quote_img: quoteImg,
  } = quoteData;

  const quoteRef = useRef(null);
  const isInView = useInView(quoteRef, { once: true, threshold: 0.5 });

  return (
    <section className="quote-section">
      <div className="quote-container" ref={quoteRef}>
        <motion.div
          className="quote-inner-container"
          initial={{ opacity: 0, x: -80 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ delay: 0.6, duration: 0.6, ease: "easeOut" }}
        >
          <div className="quote-content-container">
            {(clientName || clientRole) && (
              <div className="quote-eyebrow">
                <img className="client-icon w-4 h-4" src={userDarkIcon} alt="client-icon" />
                <div className="client-info">
                  <span className="client-name">{clientName}</span>
                  <span className="client-role">{clientRole}</span>
                </div>
              </div>
            )}

            <motion.div
              className={clsx("quote-content", {
                "max-w-[622px]": quoteImg,
                "w-full": !quoteImg,
              })}
              dangerouslySetInnerHTML={{ __html: quoteContent }}
              initial={{ opacity: 0 }}
              animate={isInView ? { opacity: 1 } : {}}
              transition={{ delay: 0.8, duration: 0.8, ease: "easeOut" }}
            />
          </div>

          {quoteImg && (
            <div className="quote-img">
              <img className="quote-image" src={quoteImg.url} alt={quoteImg.alt} />
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

QuoteComponent.propTypes = QuotePropTypes;

export default QuoteComponent;
